<template>
  <div id="tax-disclaimer" class="darkTextGrey--text">
    {{ $t('views.tax.disclaimer') }}
    <a href="https://www.filios.app/contacta" target="_blank">{{ $t('common.contactWithUs') }}.</a>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
#tax-disclaimer {
  font-size: 13px;
}
</style>
